import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'TESTBENCH__SET_USER_LIST':
            return core.setUserList(state, action.users);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/testbench/data/Users/reducer.js